import type { ReactNode } from 'react';
import { Card, Typography } from 'antd';
import { palette } from '../app/theme';
import { useDocumentTitle } from '../utils/document-head';

/** Centered sign-in card on the canvas, with the brand row above it. */
export function AuthCard({ title, subtitle, children }: { title: string; subtitle?: ReactNode; children: ReactNode }) {
  useDocumentTitle(title);
  return (
    <div className="auth-screen">
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 24, fontSize: 20, fontWeight: 700, letterSpacing: '-0.01em', color: palette.text }}>
          <span className="brand-mark" style={{ width: 36, height: 36, fontSize: 16, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#fff', borderRadius: 10 }}>G</span>
          Global CRM
        </div>
        <Card className="auth-card" style={{ maxWidth: 'none' }}>
          <div style={{ fontSize: 24, fontWeight: 600, letterSpacing: '-0.01em', color: palette.text, lineHeight: 1.3 }}>{title}</div>
          {subtitle ? (
            <Typography.Paragraph type="secondary" style={{ margin: '6px 0 24px' }}>
              {subtitle}
            </Typography.Paragraph>
          ) : (
            <div style={{ height: 20 }} />
          )}
          {children}
        </Card>
      </div>
    </div>
  );
}
